const style = (theme): any => ({
    docsCtn: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
});
export default style;
